import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservableService {
  private observedValue = new BehaviorSubject<any>(null);
  private observedValueGraphs = new BehaviorSubject<any>(null);
  private observedValueClickTabs = new BehaviorSubject<any>(null);
  private observedValueGraphsPerformance = new BehaviorSubject<any>(null);
  private observedValueClickTabsPerformance = new BehaviorSubject<any>(null);

  private _myBoolean = false;
  private _myBooleanExpense = false;
  private _myBooleanPOTrendLY = false;
  private _myBooleanTopManufacturerSpending = false;
  private _myBooleanPoAndVendorGap = false;
  private _myBooleanPoAndVendorInvoiceTrend = false;
  private _myBooleanTopManufacturerVendor = false;
  private _myBooleanBuyerTeamPerformanceTable = false;
  private _myBooleanPOBacklogGraph = false;
  private _myBooleanTopTenShipTo = false;
  private _myBooleanBuyerTeamPOGraph = false;

  public filterChange: EventEmitter<any> = new EventEmitter();
  public filterPeriodsCharts: EventEmitter<any> = new EventEmitter();
  public filterFlagsCiscoManufacturer: EventEmitter<any> = new EventEmitter();
  public filterFlagsCiscoManufacturerReturner: EventEmitter<any> = new EventEmitter();
  public filterFlagsCiscoVendor: EventEmitter<any> = new EventEmitter();
  public filterFlagsCiscoVendorReturner: EventEmitter<any> = new EventEmitter();
  public filterVendorNameManufacturer: EventEmitter<any> = new EventEmitter();

  constructor() {}

  setVariable(value: any) {
    this.observedValue.next(value);
  }

  getVariable(): Observable<any> {
    return this.observedValue.asObservable();
  }

  setVariableGraphs(value: any) {
    this.observedValueGraphs.next(value);
  }

  getVariableGraphs(): Observable<any> {
    return this.observedValueGraphs.asObservable();
  }

  getClickObservable(): Observable<any> {
    return this.observedValueClickTabs.asObservable();
  }

  setObservedClickTabs(value: any) {
    this.observedValueClickTabs.next(value);
  }

  setVariableGraphsPerformance(value: any) {
    this.observedValueGraphsPerformance.next(value);
  }

  getVariableGraphsPerformance(): Observable<any> {
    return this.observedValueGraphsPerformance.asObservable();
  }

  getClickObservablePerformance(): Observable<any> {
    return this.observedValueClickTabsPerformance.asObservable();
  }

  setObservedClickTabsPerformance(value: any) {
    this.observedValueClickTabsPerformance.next(value);
  }

  get myBoolean(): boolean {
    return this._myBoolean;
  }

  set myBoolean(value: boolean) {
    this._myBoolean = value;
  }

  get myBooleanExpense(): boolean {
    return this._myBooleanExpense;
  }

  set myBooleanExpense(value: boolean) {
    this._myBooleanExpense = value;
  }

  get myBooleanPOTrendLy(): boolean {
    return this._myBooleanPOTrendLY;
  }

  set myBooleanPOTrendLy(value: boolean) {
    this._myBooleanPOTrendLY = value;
  }

  get myBooleanTopManufacturerSpending(): boolean {
    return this._myBooleanTopManufacturerSpending;
  }

  set myBooleanTopManufacturerSpending(value: boolean) {
    this._myBooleanTopManufacturerSpending = value;
  }

  get myBooleanPoAndVendorGap(): boolean {
    return this._myBooleanPoAndVendorGap;
  }

  set myBooleanPoAndVendorGap(value: boolean) {
    this._myBooleanPoAndVendorGap = value;
  }

  get myBooleanPoAndVendorInvoiceTrend(): boolean {
    return this._myBooleanPoAndVendorInvoiceTrend;
  }

  set myBooleanPoAndVendorInvoiceTrend(value: boolean) {
    this._myBooleanPoAndVendorInvoiceTrend = value;
  }

  get myBooleanTopManufacturerVendor(): boolean {
    return this._myBooleanTopManufacturerVendor;
  }

  set myBooleanTopManufacturerVendor(value: boolean) {
    this._myBooleanTopManufacturerVendor = value;
  }

  get myBooleanBuyerTeamPerformanceTable(): boolean {
    return this._myBooleanBuyerTeamPerformanceTable;
  }

  set myBooleanBuyerTeamPerformanceTable(value: boolean) {
    this._myBooleanBuyerTeamPerformanceTable = value;
  }

  get myBooleanPOBacklogGraph(): boolean {
    return this._myBooleanPOBacklogGraph;
  }

  set myBooleanPOBacklogGraph(value: boolean) {
    this._myBooleanPOBacklogGraph = value;
  }

  get myBooleanTopTenShipTo(): boolean {
    return this._myBooleanTopTenShipTo;
  }

  set myBooleanTopTenShipTo(value: boolean) {
    this._myBooleanTopTenShipTo = value;
  }

  get myBooleanBuyerTeamPOGraph(): boolean {
    return this._myBooleanBuyerTeamPOGraph;
  }

  set myBooleanBuyerTeamPOGraph(value: boolean) {
    this._myBooleanBuyerTeamPOGraph = value;
  }
}
